import styled from 'styled-components'
import { orange, black, textMuted, rail } from '@/theme/colors'
import { text, leading } from '@/theme/typography'

// Warm tan dash used by the flight path — same decorative hairline colour as the
// itinerary timeline dashes.
const PATH_DASH = rail

/** One flight row: codes + dashed path + right meta (design `.bento-flight-row`). */
export const FlightRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
`

/** Big origin/destination airport code (design `.trip-airport` at tile size). */
export const AirportCode = styled.span`
	${text.heading}
	font-weight: 900;
	line-height: ${leading.none};
	color: ${black};
	flex-shrink: 0;
`

/** The dashed path between codes, plane glyph in the middle. */
export const FlightPath = styled.span`
	flex: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 40px;
	color: ${orange};
`

export const FlightDashes = styled.span`
	flex: 1;
	border-top: 2px dashed ${PATH_DASH};
`

/** Right-aligned meta block; both lines kept on ONE line via nowrap. */
export const FlightMeta = styled.span`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 1px;
	margin-left: 10px;
	flex-shrink: 0;
	min-width: 96px;
`

export const FlightCode = styled.span`
	${text.labelSm}
	color: ${black};
	white-space: nowrap;
`

export const FlightMetaCaption = styled.span`
	${text.caption}
	color: ${textMuted};
	white-space: nowrap;
`
